import { render } from "./project_gallery.vue?vue&type=template&id=580a77b0"
import script from "./project_gallery.vue?vue&type=script&lang=js"
export * from "./project_gallery.vue?vue&type=script&lang=js"

import "./project_gallery.vue?vue&type=style&index=0&id=580a77b0&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__